module.exports = __webpack_public_path__ + "img/cutlery.dc074a9b.svg";